"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _cccisdApollo = require("cccisd-apollo");
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _player = require("../../reducers/player.js");
var _withRecaptcha = _interopRequireDefault(require("../../helpers/withRecaptcha.js"));
var _FlowListPicker = _interopRequireDefault(require("../FlowListPicker"));
var _LanguagePicker = _interopRequireDefault(require("../LanguagePicker"));
var _Mediator = _interopRequireDefault(require("../Mediator"));
var _assignmentQuery = _interopRequireDefault(require("./assignmentQuery.graphql"));
var _flowInfoQuery = _interopRequireDefault(require("./flowInfoQuery.graphql"));
var _pawnFlowListQuery = _interopRequireDefault(require("./pawnFlowListQuery.graphql"));
var _pawnLanguageQuery = _interopRequireDefault(require("./pawnLanguageQuery.graphql"));
var _progressQuery = _interopRequireDefault(require("./progressQuery.graphql"));
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Boilerplate = window.cccisd.boilerplate;
var Cccisd = window.cccisd;
var Fortress = window.cccisd.fortress;
var repeatedFlowsKeysToOmit = ['repeatQuery', 'repeatQueryFlowVars', 'repeatQueryRequiredVariables', 'repeatQueryResultValuePath'];
var dataVarKeysToOmit = ['dataQuery', 'dataQueryFlowVars', 'dataQueryRequiredVariables', 'dataQueryResultValuePath'];
var Assignment = /*#__PURE__*/function (_React$Component) {
  _inherits(Assignment, _React$Component);
  var _super = _createSuper(Assignment);
  function Assignment() {
    var _this;
    _classCallCheck(this, Assignment);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      assignmentProgressId: null,
      chosenLanguage: null,
      chosenFlowList: null,
      randomizing: false,
      flowProgress: null,
      progressChecked: false,
      savedLanguage: null,
      savedFlowList: null,
      assignmentSavedLanguage: null,
      assignmentSavedFlowList: null,
      annotatedFlows: undefined,
      // allow children to know about network error before unmounting them
      isNetworkError: false,
      isNetworkErrorUnmountChildren: false
    });
    _defineProperty(_assertThisInitialized(_this), "sendProgressRequest", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(send) {
        var response, _response, _response$data, status;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.state.isNetworkError) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                _context.prev = 2;
                _context.next = 5;
                return send();
              case 5:
                response = _context.sent;
                status = ((_response = response) === null || _response === void 0 ? void 0 : (_response$data = _response.data) === null || _response$data === void 0 ? void 0 : _response$data.status) || 'success';
                if (!(response.status > 400 || status !== 'success')) {
                  _context.next = 9;
                  break;
                }
                throw new Error('Network error');
              case 9:
                _context.next = 14;
                break;
              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](2);
                _this.setState({
                  isNetworkError: true
                }, function () {
                  setTimeout(function () {
                    return _this.setState({
                      isNetworkErrorUnmountChildren: true
                    });
                  }, 500);
                });
              case 14:
                return _context.abrupt("return", response);
              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 11]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "checkProgress", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _this$props, flowList, flowLists, flowProgress, isPreviewMode, language, languages, surveylists, checkPromises, queryProgressPromise, queryLanguagePromise, flowListArray, queryFlowListPromise, queryAssignmentPromise;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props = _this.props, flowList = _this$props.flowList, flowLists = _this$props.flowLists, flowProgress = _this$props.flowProgress, isPreviewMode = _this$props.isPreviewMode, language = _this$props.language, languages = _this$props.languages, surveylists = _this$props.surveylists;
              if (isPreviewMode) {
                _context2.next = 10;
                break;
              }
              checkPromises = [];
              if (flowProgress === null) {
                queryProgressPromise = _this.queryProgress();
                checkPromises.push(queryProgressPromise);
              }
              if (language === null && languages.length > 1) {
                queryLanguagePromise = _this.queryLanguage();
                checkPromises.push(queryLanguagePromise);
              }
              flowListArray = surveylists ? Object.keys(surveylists) : Object.keys(flowLists);
              if (flowList === null && flowListArray.length > 1) {
                queryFlowListPromise = _this.queryFlowList();
                checkPromises.push(queryFlowListPromise);
              }
              if (flowList === null && flowListArray.length > 1 || language === null && languages.length > 1) {
                queryAssignmentPromise = _this.queryAssignment();
                checkPromises.push(queryAssignmentPromise);
              }
              _context2.next = 10;
              return Promise.all(checkPromises);
            case 10:
              _context2.next = 12;
              return _this.launchRandomizer();
            case 12:
              _this.setState({
                progressChecked: true
              });
            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    _defineProperty(_assertThisInitialized(_this), "queryProgress", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var result;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _cccisdApollo.client.query({
                query: _progressQuery["default"],
                fetchPolicy: 'network-only',
                variables: {
                  pawnId: _this.getPawnId(),
                  responseSet: [_this.getResponseSet()]
                }
              });
            case 2:
              result = _context3.sent;
              _this.setState({
                flowProgress: result.data.roles.anyRole.flowProgressList
              });
            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    _defineProperty(_assertThisInitialized(_this), "queryFlowList", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var result;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (_this.props.shouldSaveFlowList) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return");
            case 2:
              _context4.next = 4;
              return _cccisdApollo.client.query({
                query: _pawnFlowListQuery["default"],
                fetchPolicy: 'network-only',
                variables: {
                  pawnId: _this.getPawnId()
                }
              });
            case 4:
              result = _context4.sent;
              _this.setState({
                savedFlowList: result.data.roles.anyRole.fields.flowList
              });
            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));
    _defineProperty(_assertThisInitialized(_this), "queryLanguage", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var result;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (_this.props.shouldSaveLanguage) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return");
            case 2:
              _context5.next = 4;
              return _cccisdApollo.client.query({
                query: _pawnLanguageQuery["default"],
                fetchPolicy: 'network-only',
                variables: {
                  pawnId: _this.getPawnId()
                }
              });
            case 4:
              result = _context5.sent;
              _this.setState({
                savedLanguage: result.data.roles.anyRole.fields.language
              });
            case 6:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    })));
    _defineProperty(_assertThisInitialized(_this), "queryAssignment", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      var _this$props2, handle, assignmentProgressChecked, result, assignment;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _this$props2 = _this.props, handle = _this$props2.handle, assignmentProgressChecked = _this$props2.assignmentProgressChecked; // we already checked assignmentProgress in DeploymentPlayer
              if (!assignmentProgressChecked) {
                _context6.next = 3;
                break;
              }
              return _context6.abrupt("return");
            case 3:
              _context6.next = 5;
              return _cccisdApollo.client.query({
                query: _assignmentQuery["default"],
                fetchPolicy: 'network-only',
                variables: {
                  assignmentHandle: handle,
                  pawnId: _this.getPawnId(),
                  responseSet: _this.getResponseSet()
                }
              });
            case 5:
              result = _context6.sent;
              assignment = result.data.roles.anyRole.assignmentProgress;
              if (assignment.flowList) {
                _this.setState({
                  assignmentSavedFlowList: assignment.flowList
                });
              }
              if (assignment.language) {
                _this.setState({
                  assignmentSavedLanguage: assignment.language
                });
              }
            case 9:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    })));
    _defineProperty(_assertThisInitialized(_this), "launchRandomizer", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      var flowListInfo, _this$props3, isPreviewMode, flowLists, flowListRandomizer, surveylists, flowListArray;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              flowListInfo = _this.flowListInfo();
              _this$props3 = _this.props, isPreviewMode = _this$props3.isPreviewMode, flowLists = _this$props3.flowLists, flowListRandomizer = _this$props3.flowListRandomizer, surveylists = _this$props3.surveylists;
              if (!flowListInfo.randomizerNeeded) {
                _context7.next = 13;
                break;
              }
              _this.setState({
                randomizing: true
              });
              if (!isPreviewMode) {
                _context7.next = 6;
                break;
              }
              return _context7.abrupt("return");
            case 6:
              flowListArray = surveylists ? Object.keys(surveylists) : Object.keys(flowLists);
              if (!(flowListRandomizer !== null)) {
                _context7.next = 11;
                break;
              }
              flowListRandomizer(flowListArray, _this.onFlowListPicked);
              _context7.next = 13;
              break;
            case 11:
              _context7.next = 13;
              return _this.flowListRandomizer(flowListArray, _this.onFlowListPicked);
            case 13:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    })));
    _defineProperty(_assertThisInitialized(_this), "getResponseSet", function () {
      return _this.props.flowProps.responseSet || 1;
    });
    _defineProperty(_assertThisInitialized(_this), "getFlowProgress", function () {
      /* in cases where language is changed, this component refetches flowProgress for new language
       * so use progress from state instead of whatever was passed as prop */
      return _this.state.chosenLanguage ? _this.state.flowProgress || _this.props.flowProgress || [] : _this.props.flowProgress || _this.state.flowProgress || [];
    });
    _defineProperty(_assertThisInitialized(_this), "getPawnId", function () {
      return _this.props.flowProps.pawnId || Fortress.user.acting.id;
    });
    _defineProperty(_assertThisInitialized(_this), "getPawnHash", function () {
      return _this.props.flowProps.pawnHash || Fortress.user.acting.random_hash;
    });
    _defineProperty(_assertThisInitialized(_this), "languageInfo", function () {
      var _this$props4 = _this.props,
        languages = _this$props4.languages,
        handle = _this$props4.handle,
        allowLanguageChange = _this$props4.allowLanguageChange;
      var _this$state = _this.state,
        assignmentSavedLanguage = _this$state.assignmentSavedLanguage,
        savedLanguage = _this$state.savedLanguage;
      var language = _this.props.language || assignmentSavedLanguage || savedLanguage;
      if (language !== null) {
        if (languages !== null && languages.indexOf(language) === -1) {
          console.error("Specified language ".concat(language, " for assignment ").concat(handle, " not in language list ").concat(languages));
          language = languages.length === 1 ? languages[0] : undefined;
        }
        if (!allowLanguageChange || languages === null || languages.length < 2) {
          return {
            language: language,
            pickerNeeded: false
          };
        }
        if (_this.state.chosenLanguage !== null) {
          return {
            language: _this.state.chosenLanguage,
            pickerNeeded: false
          };
        }
        return {
          language: language,
          pickerNeeded: true
        };
      }
      if (languages === null || languages.length === 0) {
        return {
          language: null,
          pickerNeeded: false
        };
      }
      if (languages.length === 1) {
        return {
          language: languages[0],
          pickerNeeded: false
        };
      }
      if (_this.state.chosenLanguage === null) {
        return {
          language: null,
          pickerNeeded: true
        };
      }
      if (languages.indexOf(_this.state.chosenLanguage) === -1) {
        return {
          language: null,
          pickerNeeded: true
        };
      }
      return {
        language: _this.state.chosenLanguage,
        pickerNeeded: false
      };
    });
    _defineProperty(_assertThisInitialized(_this), "flowListInfo", function () {
      var _this$props5 = _this.props,
        flowLists = _this$props5.flowLists,
        handle = _this$props5.handle,
        surveylists = _this$props5.surveylists;
      var _this$state2 = _this.state,
        assignmentSavedFlowList = _this$state2.assignmentSavedFlowList,
        savedFlowList = _this$state2.savedFlowList;
      var flowListArray = surveylists ? Object.keys(surveylists) : Object.keys(flowLists);
      var flowList = _this.props.flowList || assignmentSavedFlowList || savedFlowList;
      if (flowList !== null) {
        if (flowListArray !== null && flowListArray.indexOf(flowList) === -1) {
          console.error("Specified flowList ".concat(flowList, " of assignment ").concat(handle, " not in flowList list ").concat(flowListArray));
          flowList = null;
        } else {
          return {
            flowList: flowList,
            randomizerNeeded: false
          };
        }
      }
      if (flowListArray.length === 0) {
        console.error('No flowLists defined');
      }
      if (flowListArray.length === 1) {
        return {
          flowList: flowListArray[0],
          randomizerNeeded: false
        };
      }
      if (_this.state.chosenFlowList === null || flowListArray.indexOf(_this.state.chosenFlowList) === -1) {
        return {
          flowList: null,
          randomizerNeeded: true
        };
      }
      return {
        flowList: _this.state.chosenFlowList,
        randomizerNeeded: false
      };
    });
    _defineProperty(_assertThisInitialized(_this), "onLanguagePicked", /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(language) {
        var prevLanguage, _this$props6, handle, languages;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(_this.props.languages.indexOf(language) !== -1)) {
                  _context8.next = 9;
                  break;
                }
                prevLanguage = _this.languageInfo().language;
                if (!(language !== prevLanguage)) {
                  _context8.next = 5;
                  break;
                }
                _context8.next = 5;
                return _this.queryProgress();
              case 5:
                _this.saveLanguage(language);
                _this.setState({
                  chosenLanguage: language
                });
                _context8.next = 12;
                break;
              case 9:
                _this$props6 = _this.props, handle = _this$props6.handle, languages = _this$props6.languages;
                console.error("Chosen language ".concat(language, " for assignment ").concat(handle, " not in language list ").concat(languages));
                _this.setState({
                  chosenLanguage: languages[0]
                });
              case 12:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));
      return function (_x2) {
        return _ref8.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "saveLanguage", /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(language) {
        var _this$props7, isPreviewMode, shouldSaveLanguage;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                // TODO: save language for pawns other than acting
                _this$props7 = _this.props, isPreviewMode = _this$props7.isPreviewMode, shouldSaveLanguage = _this$props7.shouldSaveLanguage;
                if (!(isPreviewMode || !shouldSaveLanguage)) {
                  _context9.next = 3;
                  break;
                }
                return _context9.abrupt("return");
              case 3:
                _context9.next = 5;
                return _this.sendProgressRequest(function () {
                  return _cccisdAxios["default"].put(Boilerplate.route('api.nexus.pawn.update', {
                    pawn: _this.getPawnId()
                  }), {
                    pawnId: _this.getPawnId(),
                    pawnHash: _this.getPawnHash(),
                    language: language
                  });
                });
              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));
      return function (_x3) {
        return _ref9.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "onFlowListPicked", /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(flowList) {
        var _this$props8, flowLists, handle, surveylists, flowListArray;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this$props8 = _this.props, flowLists = _this$props8.flowLists, handle = _this$props8.handle, surveylists = _this$props8.surveylists;
                flowListArray = surveylists ? Object.keys(surveylists) : Object.keys(flowLists);
                if (!(flowListArray.indexOf(flowList) !== -1)) {
                  _context10.next = 8;
                  break;
                }
                _context10.next = 5;
                return _this.saveFlowList(flowList);
              case 5:
                _this.setState({
                  chosenFlowList: flowList,
                  randomizing: false
                });
                _context10.next = 10;
                break;
              case 8:
                console.error("Chosen flowList ".concat(flowList, " for assignment ").concat(handle, " not in flowLists ").concat(flowListArray));
                _this.setState({
                  chosenFlowList: flowListArray[0],
                  randomizing: false
                });
              case 10:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));
      return function (_x4) {
        return _ref10.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "saveFlowList", /*#__PURE__*/function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(flowList) {
        var _this$props9, isPreviewMode, shouldSaveFlowList;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this$props9 = _this.props, isPreviewMode = _this$props9.isPreviewMode, shouldSaveFlowList = _this$props9.shouldSaveFlowList;
                if (!(isPreviewMode || !shouldSaveFlowList)) {
                  _context11.next = 3;
                  break;
                }
                return _context11.abrupt("return");
              case 3:
                _context11.next = 5;
                return _this.sendProgressRequest(function () {
                  return _cccisdAxios["default"].put(Boilerplate.route('api.nexus.pawn.update', {
                    pawn: _this.getPawnId()
                  }), {
                    pawnId: _this.getPawnId(),
                    pawnHash: _this.getPawnHash(),
                    flowList: flowList
                  });
                });
              case 5:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));
      return function (_x5) {
        return _ref11.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "flowListRandomizer", /*#__PURE__*/function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(flowListArray, onFlowListPicked) {
        var flowList;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                // TODO: check flowListArray chosen in other response sets, do not
                // re-use if we haven't used them all
                flowList = flowListArray[Math.floor(Math.random() * flowListArray.length)];
                _context12.next = 3;
                return onFlowListPicked(flowList);
              case 3:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));
      return function (_x6, _x7) {
        return _ref12.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getAnnotatedFlows", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
      var _this$props10, allSurveyProgress, flowLists, genericFlowProps, isPreviewMode, options, surveylists, requiredOptions, language, flowList, responseSet, flows, _annotatedFlows, formFlowObjects, suffix, shownOnly, includingRepeats, includingData, annotatedFlows, _iterator, _step, flow, handle, isComplete, isStarted, _iterator2, _step2, subProgress, keys, flowProgress, _iterator3, _step3, progress, flowProps, tempFlow;
      return _regeneratorRuntime().wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _this$props10 = _this.props, allSurveyProgress = _this$props10.allSurveyProgress, flowLists = _this$props10.flowLists, genericFlowProps = _this$props10.flowProps, isPreviewMode = _this$props10.isPreviewMode, options = _this$props10.options, surveylists = _this$props10.surveylists, requiredOptions = _this$props10.requiredOptions;
              language = _this.languageInfo().language;
              flowList = _this.flowListInfo().flowList;
              responseSet = _this.getResponseSet();
              /* If `allSurveyProgress` is passed as prop, then it has all the info we need.
               * This is not guaranteed if someone uses <Assignment/> directly instead of
               * via <DeploymentPlayer/>, so keep the other logic for backwards compatibility
               */
              if (!(allSurveyProgress && _typeof(allSurveyProgress) === 'object' && !Array.isArray(allSurveyProgress) && typeof language === 'string' && typeof flowList === 'string' && typeof responseSet === 'number')) {
                _context13.next = 17;
                break;
              }
              // Initial state from backend
              flows = (0, _get2["default"])(allSurveyProgress, "".concat(flowList, ".").concat(language), []); // get into proper structure
              _annotatedFlows = flows.filter(function (flow) {
                var showIfOption = (0, _get2["default"])(flow, 'survey_settings.showIfOption');
                // very old surveys might not have this key defined in settings
                if (!showIfOption) {
                  return true;
                }
                return Array.isArray(showIfOption) ? showIfOption.some(function (opt) {
                  return options.includes(opt);
                }) : options.includes(showIfOption);
              }).map(function (flow) {
                var showIfOption = (0, _get2["default"])(flow, 'survey_settings.showIfOption', [flow.survey_handle]);
                var isRequired = (0, _get2["default"])(flow, 'survey_settings.isRequired', false);
                if (Array.isArray(requiredOptions)) {
                  isRequired = Array.isArray(showIfOption) ? showIfOption.some(function (opt) {
                    return requiredOptions.includes(opt);
                  }) : requiredOptions.includes(showIfOption);
                }
                var flowSettings = typeof flow.flow_settings === 'string' ? JSON.parse(flow.flow_settings) : flow.flow_settings;
                var surveySettings = typeof flow.survey_settings === 'string' ? JSON.parse(flow.survey_settings) : flow.survey_settings;
                return _objectSpread(_objectSpread(_objectSpread({
                  flowId: flow.flow_id,
                  flowSettings: flowSettings,
                  handle: flow.flow_handle,
                  isComplete: !isPreviewMode && Boolean(flow.flow_finished),
                  isPreviewMode: isPreviewMode,
                  isRequired: isRequired,
                  isStarted: !isPreviewMode && Boolean(flow.flow_started),
                  language: language,
                  lastVisited: !isPreviewMode && flow.flow_last_visited,
                  ordinalPosition: flow.survey_order,
                  pawnId: _this.getPawnId(),
                  pawnHash: _this.getPawnHash(),
                  responseSet: responseSet,
                  showIfOption: showIfOption,
                  surveySettings: (0, _omit2["default"])(surveySettings, [].concat(repeatedFlowsKeysToOmit, dataVarKeysToOmit))
                }, surveySettings), _typeof(flow.flowProps) === 'object' ? flow.flowProps : {}), genericFlowProps);
              }); // Handle if flow has flow.repeatQuery
              _context13.next = 9;
              return _this.getRepeatedFlows(_annotatedFlows);
            case 9:
              _annotatedFlows = _context13.sent;
              _context13.next = 12;
              return _this.getFlowVarData(_annotatedFlows);
            case 12:
              _annotatedFlows = _context13.sent;
              _context13.next = 15;
              return _this.setProgressBar(_annotatedFlows);
            case 15:
              _this.setState({
                annotatedFlows: _annotatedFlows
              });
              return _context13.abrupt("return");
            case 17:
              // All code below is for backwards compatibility only
              formFlowObjects = flowLists ? flowLists[flowList] : surveylists[flowList];
              suffix = language && !surveylists ? "-".concat(language) : '';
              if (formFlowObjects) {
                _context13.next = 21;
                break;
              }
              return _context13.abrupt("return", undefined);
            case 21:
              shownOnly = formFlowObjects.filter(function (flow) {
                if (!flow.showIfOption) {
                  return true;
                }
                var showIfOption = Array.isArray(flow.showIfOption) ? flow.showIfOption : [flow.showIfOption];
                return showIfOption.some(function (opt) {
                  return options.includes(opt);
                });
              });
              _context13.next = 24;
              return _this.getRepeatedFlows(shownOnly);
            case 24:
              includingRepeats = _context13.sent;
              _context13.next = 27;
              return _this.getFlowVarData(includingRepeats);
            case 27:
              includingData = _context13.sent;
              annotatedFlows = [];
              _iterator = _createForOfIteratorHelper(includingData);
              _context13.prev = 30;
              _iterator.s();
            case 32:
              if ((_step = _iterator.n()).done) {
                _context13.next = 91;
                break;
              }
              flow = _step.value;
              flow = typeof flow === 'string' ? {
                handle: flow
              } : flow;
              handle = "".concat(flow.handle).concat(suffix);
              isComplete = false;
              isStarted = false;
              if (!flow.subFlowProgress) {
                _context13.next = 63;
                break;
              }
              _iterator2 = _createForOfIteratorHelper(flow.subFlowProgress);
              _context13.prev = 40;
              _iterator2.s();
            case 42:
              if ((_step2 = _iterator2.n()).done) {
                _context13.next = 53;
                break;
              }
              subProgress = _step2.value;
              if (!(subProgress.responseSet === responseSet)) {
                _context13.next = 51;
                break;
              }
              if (!(subProgress.flowLanguage && subProgress.flowLanguage !== language)) {
                _context13.next = 47;
                break;
              }
              return _context13.abrupt("continue", 51);
            case 47:
              keys = Object.keys(subProgress);
              if (keys.includes('completed')) {
                isComplete = subProgress.completed;
              }
              if (keys.includes('started')) {
                isStarted = subProgress.started;
              }
              return _context13.abrupt("break", 53);
            case 51:
              _context13.next = 42;
              break;
            case 53:
              _context13.next = 58;
              break;
            case 55:
              _context13.prev = 55;
              _context13.t0 = _context13["catch"](40);
              _iterator2.e(_context13.t0);
            case 58:
              _context13.prev = 58;
              _iterator2.f();
              return _context13.finish(58);
            case 61:
              _context13.next = 83;
              break;
            case 63:
              flowProgress = _this.getFlowProgress();
              _iterator3 = _createForOfIteratorHelper(flowProgress);
              _context13.prev = 65;
              _iterator3.s();
            case 67:
              if ((_step3 = _iterator3.n()).done) {
                _context13.next = 75;
                break;
              }
              progress = _step3.value;
              if (!(progress.flowHandle === handle && progress.responseSet === responseSet && progress.flowLanguage === language)) {
                _context13.next = 73;
                break;
              }
              isComplete = progress.completed;
              isStarted = progress.started;
              return _context13.abrupt("break", 75);
            case 73:
              _context13.next = 67;
              break;
            case 75:
              _context13.next = 80;
              break;
            case 77:
              _context13.prev = 77;
              _context13.t1 = _context13["catch"](65);
              _iterator3.e(_context13.t1);
            case 80:
              _context13.prev = 80;
              _iterator3.f();
              return _context13.finish(80);
            case 83:
              flowProps = flow.flowProps || {};
              tempFlow = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, flow), genericFlowProps), flowProps), {}, {
                handle: handle,
                isComplete: isPreviewMode ? false : isComplete,
                isPreviewMode: isPreviewMode,
                isStarted: isPreviewMode ? false : isStarted,
                pawnId: flow.pawnId || _this.getPawnId(),
                pawnHash: flow.pawnHash || _this.getPawnHash(),
                responseSet: responseSet
              });
              if (Array.isArray(requiredOptions)) {
                tempFlow.isRequired = Array.isArray(tempFlow.showIfOption) ? tempFlow.showIfOption.some(function (opt) {
                  return requiredOptions.includes(opt);
                }) : requiredOptions.includes(tempFlow.showIfOption);
              }
              if (tempFlow.isRequired === undefined) {
                tempFlow.isRequired = true;
              }
              if (language && surveylists) {
                tempFlow.language = language;
              }
              annotatedFlows.push(tempFlow);
            case 89:
              _context13.next = 32;
              break;
            case 91:
              _context13.next = 96;
              break;
            case 93:
              _context13.prev = 93;
              _context13.t2 = _context13["catch"](30);
              _iterator.e(_context13.t2);
            case 96:
              _context13.prev = 96;
              _iterator.f();
              return _context13.finish(96);
            case 99:
              _context13.next = 101;
              return _this.addFlowInfo(annotatedFlows);
            case 101:
              _context13.next = 103;
              return _this.setProgressBar(annotatedFlows);
            case 103:
              annotatedFlows.sort(_this.sortByOrdinalPosition);
              _this.setState({
                annotatedFlows: annotatedFlows
              });
            case 105:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, null, [[30, 93, 96, 99], [40, 55, 58, 61], [65, 77, 80, 83]]);
    })));
    _defineProperty(_assertThisInitialized(_this), "sortByOrdinalPosition", function (f1, f2) {
      if (f1.ordinalPosition < f2.ordinalPosition) {
        return -1;
      }
      if (f1.ordinalPosition > f2.ordinalPosition) {
        return 1;
      }
      return 0;
    });
    _defineProperty(_assertThisInitialized(_this), "getRepeatedFlows", /*#__PURE__*/function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(flows) {
        var flowsWithRepeats, _iterator4, _step4, flow, processedFlows;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                flowsWithRepeats = [];
                _iterator4 = _createForOfIteratorHelper(flows);
                _context14.prev = 2;
                _iterator4.s();
              case 4:
                if ((_step4 = _iterator4.n()).done) {
                  _context14.next = 12;
                  break;
                }
                flow = _step4.value;
                _context14.next = 8;
                return _this.processRepeatedFlow(flow);
              case 8:
                processedFlows = _context14.sent;
                flowsWithRepeats = flowsWithRepeats.concat(processedFlows);
              case 10:
                _context14.next = 4;
                break;
              case 12:
                _context14.next = 17;
                break;
              case 14:
                _context14.prev = 14;
                _context14.t0 = _context14["catch"](2);
                _iterator4.e(_context14.t0);
              case 17:
                _context14.prev = 17;
                _iterator4.f();
                return _context14.finish(17);
              case 20:
                return _context14.abrupt("return", flowsWithRepeats);
              case 21:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, null, [[2, 14, 17, 20]]);
      }));
      return function (_x8) {
        return _ref14.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "processRepeatedFlow", /*#__PURE__*/function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(flow) {
        var variables, repeatQueryResult, resultList;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (flow.repeatQuery) {
                  _context15.next = 2;
                  break;
                }
                return _context15.abrupt("return", [flow]);
              case 2:
                variables = _this.buildRequiredVariables(flow.repeatQueryRequiredVariables, flow);
                _context15.next = 5;
                return _cccisdApollo.client.query({
                  query: (0, _cccisdApollo.gql)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n                ", "\n            "])), flow.repeatQuery),
                  fetchPolicy: 'network-only',
                  variables: variables
                });
              case 5:
                repeatQueryResult = _context15.sent;
                resultList = (0, _get2["default"])(repeatQueryResult.data, flow.repeatQueryResultValuePath, []);
                return _context15.abrupt("return", _this.getBuiltRepeatedFlows(resultList, flow));
              case 8:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }));
      return function (_x9) {
        return _ref15.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getBuiltRepeatedFlows", function (resultList, flow) {
      var builtFlows = [];
      var varDefs = flow.repeatQueryFlowVars;
      if (!resultList.length || !varDefs) {
        return builtFlows;
      }
      var _iterator5 = _createForOfIteratorHelper(resultList),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var thisResult = _step5.value;
          var flowVars = {};
          var _iterator6 = _createForOfIteratorHelper(varDefs),
            _step6;
          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var varDef = _step6.value;
              var val = varDef.value ? (0, _get2["default"])(thisResult, varDef.value, undefined) : thisResult;
              var tempObj = _defineProperty({}, varDef.key, val);
              var objectData = _this.setObjectData(thisResult, varDef);
              Object.assign(flowVars, tempObj, objectData);
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
          builtFlows.push(Object.assign({}, (0, _omit2["default"])(flow, repeatedFlowsKeysToOmit), flowVars));
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      return builtFlows;
    });
    _defineProperty(_assertThisInitialized(_this), "getFlowVarData", /*#__PURE__*/function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(flows) {
        var updatedFlows, _iterator7, _step7, flow, dataResult, updatedFlow;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                updatedFlows = [];
                _iterator7 = _createForOfIteratorHelper(flows);
                _context16.prev = 2;
                _iterator7.s();
              case 4:
                if ((_step7 = _iterator7.n()).done) {
                  _context16.next = 16;
                  break;
                }
                flow = _step7.value;
                if (flow.dataQuery) {
                  _context16.next = 9;
                  break;
                }
                updatedFlows.push(flow);
                return _context16.abrupt("continue", 14);
              case 9:
                _context16.next = 11;
                return _this.runFlowVarDataQuery(flow);
              case 11:
                dataResult = _context16.sent;
                updatedFlow = _this.addFlowVarsFromData(dataResult, flow);
                updatedFlows.push(updatedFlow);
              case 14:
                _context16.next = 4;
                break;
              case 16:
                _context16.next = 21;
                break;
              case 18:
                _context16.prev = 18;
                _context16.t0 = _context16["catch"](2);
                _iterator7.e(_context16.t0);
              case 21:
                _context16.prev = 21;
                _iterator7.f();
                return _context16.finish(21);
              case 24:
                return _context16.abrupt("return", updatedFlows);
              case 25:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, null, [[2, 18, 21, 24]]);
      }));
      return function (_x10) {
        return _ref16.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "runFlowVarDataQuery", /*#__PURE__*/function () {
      var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17(flow) {
        var variables, dataQueryResult;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                variables = _this.buildRequiredVariables(flow.dataQueryRequiredVariables, flow);
                _context17.next = 3;
                return _cccisdApollo.client.query({
                  query: (0, _cccisdApollo.gql)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n                ", "\n            "])), flow.dataQuery),
                  fetchPolicy: 'network-only',
                  variables: variables
                });
              case 3:
                dataQueryResult = _context17.sent;
                return _context17.abrupt("return", (0, _get2["default"])(dataQueryResult.data, flow.dataQueryResultValuePath, {}));
              case 5:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17);
      }));
      return function (_x11) {
        return _ref17.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "addFlowVarsFromData", function (dataResult, flow) {
      var varDefs = flow.dataQueryFlowVars;
      var flowVars = {};
      if (!(0, _isEmpty2["default"])(dataResult) && varDefs.length) {
        var _iterator8 = _createForOfIteratorHelper(varDefs),
          _step8;
        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var varDef = _step8.value;
            var val = varDef.value ? (0, _get2["default"])(dataResult, varDef.value, undefined) : dataResult;
            val = varDef.userList ? _this.makeUserList(val, varDef) : val;
            var tempObj = varDef.userList ? _defineProperty({}, varDef.key, _defineProperty({}, varDef.userList, val)) : _defineProperty({}, varDef.key, val);
            var objectData = _this.setObjectData(dataResult, varDef);
            Object.assign(flowVars, tempObj, objectData);
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }
      }
      return Object.assign({}, (0, _omit2["default"])(flow, dataVarKeysToOmit), flowVars);
    });
    _defineProperty(_assertThisInitialized(_this), "addFlowInfo", /*#__PURE__*/function () {
      var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18(annotatedFlows) {
        var language, flowHandles, result, flowList, surveyList, _iterator9, _step9, _loop;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                language = _this.languageInfo().language;
                flowHandles = annotatedFlows.map(function (e) {
                  return e.handle;
                });
                _context18.next = 4;
                return _cccisdApollo.client.query({
                  query: _flowInfoQuery["default"],
                  fetchPolicy: 'network-only',
                  variables: {
                    language: language,
                    flowHandles: flowHandles
                  }
                });
              case 4:
                result = _context18.sent;
                flowList = (0, _get2["default"])(result, 'data.flows.flowList', []);
                surveyList = (0, _get2["default"])(result, 'data.flows.surveyList', []);
                _iterator9 = _createForOfIteratorHelper(annotatedFlows);
                try {
                  _loop = function _loop() {
                    var f = _step9.value;
                    var flowMatch = flowList.find(function (e) {
                      return e.flowHandle === f.handle;
                    });
                    if (flowMatch) {
                      f.flowId = flowMatch.flowId;
                      f.flowSettings = flowMatch.settings;
                    }
                    var surveyMatch = surveyList.find(function (e) {
                      return e.surveyHandle === f.handle;
                    });
                    if (surveyMatch) {
                      f.surveySettings = surveyMatch.settings;
                      f.ordinalPosition = surveyMatch.position;
                    }
                  };
                  for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                    _loop();
                  }
                } catch (err) {
                  _iterator9.e(err);
                } finally {
                  _iterator9.f();
                }
              case 9:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18);
      }));
      return function (_x12) {
        return _ref20.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "setObjectData", function (data, varDef) {
      var dataObj = {};
      if (!varDef.objectDef || !varDef.key) {
        return dataObj;
      }
      var _iterator10 = _createForOfIteratorHelper(varDef.objectDef),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var objDef = _step10.value;
          var val = objDef.value ? (0, _get2["default"])(data, objDef.value, undefined) : data;
          var tempObj = _defineProperty({}, objDef.key, val);
          Object.assign(dataObj, tempObj);
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
      return _defineProperty({}, varDef.key, dataObj);
    });
    _defineProperty(_assertThisInitialized(_this), "makeUserList", function (value, varDef) {
      if (!varDef.userList || !Array.isArray(value)) {
        return value;
      }
      var pawnIdPath = varDef.pawnIdPath || 'pawn.pawnId';
      var pawnHashPath = varDef.pawnHashPath || 'pawn.pawnHash';
      var namePath = varDef.namePath || 'user.fullName';
      var userList = [];
      var _iterator11 = _createForOfIteratorHelper(value),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var val = _step11.value;
          userList.push({
            pawnId: (0, _get2["default"])(val, pawnIdPath, undefined),
            pawnHash: (0, _get2["default"])(val, pawnHashPath, undefined),
            name: (0, _get2["default"])(val, namePath, undefined)
          });
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
      return userList;
    });
    _defineProperty(_assertThisInitialized(_this), "buildRequiredVariables", function (reqVars, flow) {
      var variables = {};
      flow.pawnId = flow.pawnId || _this.getPawnId();
      flow.pawnHash = flow.pawnHash || _this.getPawnHash();
      if (reqVars && Array.isArray(reqVars)) {
        var _iterator12 = _createForOfIteratorHelper(reqVars),
          _step12;
        try {
          for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
            var rv = _step12.value;
            var value = void 0;
            if (rv.cccisdSource) {
              value = (0, _get2["default"])(Cccisd, rv.cccisdSource, undefined);
            } else if (rv.flowProp) {
              value = flow[rv.flowProp];
            }
            variables[rv.variable] = value;
          }
        } catch (err) {
          _iterator12.e(err);
        } finally {
          _iterator12.f();
        }
      }
      return variables;
    });
    _defineProperty(_assertThisInitialized(_this), "onFlowStarted", /*#__PURE__*/function () {
      var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19(flow) {
        var isPreviewMode, langInfo, flowListInfo, postInfo, response, commonData, promises;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                isPreviewMode = _this.props.isPreviewMode;
                if (!isPreviewMode) {
                  _context19.next = 3;
                  break;
                }
                return _context19.abrupt("return");
              case 3:
                langInfo = _this.languageInfo();
                flowListInfo = _this.flowListInfo();
                postInfo = {
                  deploymentId: _this.props.deploymentId,
                  assignment: _this.props.handle,
                  flowlist: flowListInfo.flowList,
                  language: langInfo.language,
                  mostRecentFlow: flow.handle,
                  pawnHash: _this.getPawnHash(),
                  pawnId: _this.getPawnId(),
                  responseSet: _this.getResponseSet()
                };
                _context19.next = 8;
                return _this.sendProgressRequest(function () {
                  return _cccisdAxios["default"].post(Boilerplate.route('api.assignmentProgress.update'), postInfo, {
                    timeout: 15 * 1000
                  });
                });
              case 8:
                response = _context19.sent;
                _this.setState({
                  assignmentProgressId: response.assignmentProgressId
                });
                if (!flow.preFlowRoutes) {
                  _context19.next = 15;
                  break;
                }
                commonData = {
                  deploymentId: _this.props.deploymentId,
                  assignment: _this.props.handle,
                  flowlist: flowListInfo.flowList,
                  language: langInfo.language,
                  flow: flow.handle,
                  pawnHash: _this.getPawnHash(),
                  pawnId: _this.getPawnId(),
                  responseSet: _this.getResponseSet()
                };
                promises = flow.preFlowRoutes.map(function (r) {
                  var routeData = r.settings || {};
                  routeData = Object.assign(routeData, commonData);
                  return _this.sendProgressRequest(function () {
                    return _cccisdAxios["default"].post(Boilerplate.route(r.route), routeData, {
                      timeout: 15 * 1000
                    });
                  });
                });
                _context19.next = 15;
                return Promise.all(promises);
              case 15:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19);
      }));
      return function (_x13) {
        return _ref22.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "onFlowComplete", /*#__PURE__*/function () {
      var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20(flow) {
        var completionInfo,
          langInfo,
          flowListInfo,
          commonData,
          promises,
          _args20 = arguments;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                completionInfo = _args20.length > 1 && _args20[1] !== undefined ? _args20[1] : {};
                if (!_this.props.isPreviewMode) {
                  _context20.next = 3;
                  break;
                }
                return _context20.abrupt("return");
              case 3:
                if (!flow.postFlowRoutes) {
                  _context20.next = 10;
                  break;
                }
                langInfo = _this.languageInfo();
                flowListInfo = _this.flowListInfo();
                commonData = {
                  deploymentId: _this.props.deploymentId,
                  assignment: _this.props.handle,
                  flowlist: flowListInfo.flowList,
                  language: langInfo.language,
                  flow: flow.handle,
                  pawnHash: _this.getPawnHash(),
                  pawnId: _this.getPawnId(),
                  responseSet: _this.getResponseSet()
                };
                promises = flow.postFlowRoutes.map(function (r) {
                  var routeData = r.settings || {};
                  routeData = Object.assign(routeData, commonData);
                  return _this.sendProgressRequest(function () {
                    return _cccisdAxios["default"].post(Boilerplate.route(r.route), routeData);
                  });
                });
                _context20.next = 10;
                return Promise.all(promises);
              case 10:
                if (!_this.props.onFlowComplete) {
                  _context20.next = 13;
                  break;
                }
                _context20.next = 13;
                return _this.props.onFlowComplete(_objectSpread({
                  flow: flow
                }, completionInfo));
              case 13:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20);
      }));
      return function (_x14) {
        return _ref23.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "onAlreadyComplete", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
      var onAlreadyComplete, language, _flowList, pawnId;
      return _regeneratorRuntime().wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              onAlreadyComplete = _this.props.onAlreadyComplete;
              if (!onAlreadyComplete) {
                _context21.next = 7;
                break;
              }
              language = _this.languageInfo().language;
              _flowList = _this.flowListInfo().flowList;
              pawnId = _this.getPawnId();
              _context21.next = 7;
              return onAlreadyComplete(language, _flowList, pawnId);
            case 7:
            case "end":
              return _context21.stop();
          }
        }
      }, _callee21);
    })));
    _defineProperty(_assertThisInitialized(_this), "onAssignmentComplete", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
      var isPreviewMode, langInfo, flowListInfo, postInfo;
      return _regeneratorRuntime().wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              isPreviewMode = _this.props.isPreviewMode;
              if (!isPreviewMode) {
                _context22.next = 3;
                break;
              }
              return _context22.abrupt("return");
            case 3:
              // Requirements complete
              langInfo = _this.languageInfo();
              flowListInfo = _this.flowListInfo();
              postInfo = {
                deploymentId: _this.props.deploymentId,
                assignment: _this.props.handle,
                flowlist: flowListInfo.flowList,
                isComplete: true,
                language: langInfo.language,
                pawnHash: _this.getPawnHash(),
                pawnId: _this.getPawnId(),
                responseSet: _this.getResponseSet()
              };
              _context22.next = 8;
              return _this.sendProgressRequest(function () {
                return _cccisdAxios["default"].post(Boilerplate.route('api.assignmentProgress.update'), postInfo);
              });
            case 8:
            case "end":
              return _context22.stop();
          }
        }
      }, _callee22);
    })));
    _defineProperty(_assertThisInitialized(_this), "onComplete", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
      var onComplete, language, _flowList2, pawnId;
      return _regeneratorRuntime().wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              // All content complete
              onComplete = _this.props.onComplete;
              if (!(onComplete !== null)) {
                _context23.next = 7;
                break;
              }
              language = _this.languageInfo().language;
              _flowList2 = _this.flowListInfo().flowList;
              pawnId = _this.getPawnId();
              _context23.next = 7;
              return _this.processOnComplete(onComplete, language, _flowList2, pawnId);
            case 7:
            case "end":
              return _context23.stop();
          }
        }
      }, _callee23);
    })));
    _defineProperty(_assertThisInitialized(_this), "onModuleComplete", /*#__PURE__*/function () {
      var _ref27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24(completionInfo) {
        var moduleId, isPreviewMode, langInfo, flowListInfo, postInfo;
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                moduleId = completionInfo.moduleId;
                isPreviewMode = _this.props.isPreviewMode;
                if (!(isPreviewMode || moduleId === undefined)) {
                  _context24.next = 4;
                  break;
                }
                return _context24.abrupt("return");
              case 4:
                langInfo = _this.languageInfo();
                flowListInfo = _this.flowListInfo();
                postInfo = {
                  deploymentId: _this.props.deploymentId,
                  assignment: _this.props.handle,
                  flowlist: flowListInfo.flowList,
                  isModuleComplete: true,
                  moduleId: moduleId,
                  language: langInfo.language,
                  pawnHash: _this.getPawnHash(),
                  pawnId: _this.getPawnId(),
                  responseSet: _this.getResponseSet()
                };
                _context24.next = 9;
                return _this.sendProgressRequest(function () {
                  return _cccisdAxios["default"].post(Boilerplate.route('api.assignmentProgress.update'), postInfo);
                });
              case 9:
                if (!_this.props.onModuleComplete) {
                  _context24.next = 12;
                  break;
                }
                _context24.next = 12;
                return _this.props.onModuleComplete(completionInfo);
              case 12:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24);
      }));
      return function (_x15) {
        return _ref27.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "processOnComplete", /*#__PURE__*/function () {
      var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee25(onComplete, language, flowList, pawnId) {
        var location;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                if (onComplete) {
                  _context25.next = 2;
                  break;
                }
                return _context25.abrupt("return");
              case 2:
                if (!(typeof onComplete === 'function')) {
                  _context25.next = 6;
                  break;
                }
                _context25.next = 5;
                return onComplete(language, flowList, pawnId);
              case 5:
                return _context25.abrupt("return");
              case 6:
                _context25.t0 = onComplete.action;
                _context25.next = _context25.t0 === 'redirect' ? 9 : 12;
                break;
              case 9:
                location = !onComplete.settings.isExternal ? Boilerplate.url(onComplete.settings.location) : onComplete.settings.location;
                window.location.replace(location);
                return _context25.abrupt("break", 13);
              case 12:
                return _context25.abrupt("break", 13);
              case 13:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25);
      }));
      return function (_x16, _x17, _x18, _x19) {
        return _ref28.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "setProgressBar", /*#__PURE__*/function () {
      var _ref29 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee26(annotatedFlows) {
        var initialProgressBar, _iterator13, _step13, flow, status, processedGroups, progressBar, _i, _initialProgressBar, pbObj, updatedPbObj, flowData, allComplete, noneStarted, _iterator14, _step14, innerPbObj;
        return _regeneratorRuntime().wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                initialProgressBar = [];
                _iterator13 = _createForOfIteratorHelper(annotatedFlows);
                try {
                  for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
                    flow = _step13.value;
                    status = flow.isComplete ? 'completed' : '';
                    if (!status) {
                      status = flow.isStarted ? 'started' : 'not_started';
                    }
                    if (flow.isPreview) {
                      status = 'not_started';
                    }
                    initialProgressBar.push({
                      flowData: _defineProperty({}, "".concat(flow.handle, "_").concat(flow.pawnId), status),
                      isCurrent: false,
                      isMilestone: flow.isMilestone || false,
                      groupName: flow.progressBarGroup,
                      status: status
                    });
                  }
                } catch (err) {
                  _iterator13.e(err);
                } finally {
                  _iterator13.f();
                }
                processedGroups = [];
                progressBar = [];
                _i = 0, _initialProgressBar = initialProgressBar;
              case 6:
                if (!(_i < _initialProgressBar.length)) {
                  _context26.next = 44;
                  break;
                }
                pbObj = _initialProgressBar[_i];
                updatedPbObj = Object.assign({}, pbObj);
                if (!pbObj.groupName) {
                  _context26.next = 39;
                  break;
                }
                if (!processedGroups.includes(pbObj.groupName)) {
                  _context26.next = 12;
                  break;
                }
                return _context26.abrupt("continue", 41);
              case 12:
                flowData = {};
                allComplete = true;
                noneStarted = true;
                _iterator14 = _createForOfIteratorHelper(initialProgressBar);
                _context26.prev = 16;
                _iterator14.s();
              case 18:
                if ((_step14 = _iterator14.n()).done) {
                  _context26.next = 27;
                  break;
                }
                innerPbObj = _step14.value;
                if (!(pbObj.groupName !== innerPbObj.groupName)) {
                  _context26.next = 22;
                  break;
                }
                return _context26.abrupt("continue", 25);
              case 22:
                if (['completed', 'started'].includes(innerPbObj.status)) {
                  noneStarted = false;
                }
                if (['not_started', 'started'].includes(innerPbObj.status)) {
                  allComplete = false;
                }
                flowData = Object.assign(flowData, innerPbObj.flowData);
              case 25:
                _context26.next = 18;
                break;
              case 27:
                _context26.next = 32;
                break;
              case 29:
                _context26.prev = 29;
                _context26.t0 = _context26["catch"](16);
                _iterator14.e(_context26.t0);
              case 32:
                _context26.prev = 32;
                _iterator14.f();
                return _context26.finish(32);
              case 35:
                updatedPbObj.flowData = flowData;
                updatedPbObj.status = allComplete ? 'completed' : '';
                if (!updatedPbObj.status) {
                  updatedPbObj.status = noneStarted ? 'not_started' : 'started';
                }
                processedGroups.push(pbObj.groupName);
              case 39:
                delete updatedPbObj.groupName;
                progressBar.push(updatedPbObj);
              case 41:
                _i++;
                _context26.next = 6;
                break;
              case 44:
                _context26.next = 46;
                return _this.props.setProgressBar(progressBar);
              case 46:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, null, [[16, 29, 32, 35]]);
      }));
      return function (_x20) {
        return _ref29.apply(this, arguments);
      };
    }());
    return _this;
  }
  _createClass(Assignment, [{
    key: "componentDidMount",
    value:
    /* /////////////////////////////////////////////////////////////////////////
    // REACT LIFECYCLE METHODS ////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */

    function componentDidMount() {
      this.checkProgress();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.setProgressBar([]);
    }

    /* /////////////////////////////////////////////////////////////////////////
    // CLASS METHODS //////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */
  }, {
    key: "render",
    value:
    /* /////////////////////////////////////////////////////////////////////////
    // RENDER /////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */

    function render() {
      var _this$props11 = this.props,
        deploymentId = _this$props11.deploymentId,
        deploymentSettings = _this$props11.deploymentSettings,
        parentDeploymentId = _this$props11.parentDeploymentId,
        relatedDeploymentId = _this$props11.relatedDeploymentId,
        flowLists = _this$props11.flowLists,
        handle = _this$props11.handle,
        isFinalTestMode = _this$props11.isFinalTestMode,
        isPreviewMode = _this$props11.isPreviewMode,
        label = _this$props11.label,
        languagePicker = _this$props11.languagePicker,
        languages = _this$props11.languages,
        allowRetake = _this$props11.allowRetake,
        surveylists = _this$props11.surveylists,
        mediatorProps = _this$props11.mediatorProps,
        setIsShowingLayoutBgColor = _this$props11.setIsShowingLayoutBgColor,
        currentLayout = _this$props11.currentLayout;
      var _this$state3 = this.state,
        annotatedFlows = _this$state3.annotatedFlows,
        progressChecked = _this$state3.progressChecked,
        randomizing = _this$state3.randomizing,
        isNetworkError = _this$state3.isNetworkError,
        isNetworkErrorUnmountChildren = _this$state3.isNetworkErrorUnmountChildren;
      if (isNetworkError && isNetworkErrorUnmountChildren) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "alert alert-warning"
        }, /*#__PURE__*/_react["default"].createElement("p", null, "A network error has occurred. Please refresh your browser. You may have to resubmit any previously submitted responses. If the error persists, please contact technical support at", ' ', /*#__PURE__*/_react["default"].createElement("a", {
          href: "mailto:support@3cisd.com"
        }, "support@3cisd.com"), "."), /*#__PURE__*/_react["default"].createElement("button", {
          className: "btn btn-default",
          type: "button",
          onClick: function onClick() {
            return window.location.reload();
          },
          style: {
            marginTop: 15
          }
        }, "Try Again"));
      }
      if (randomizing && isPreviewMode) {
        return /*#__PURE__*/_react["default"].createElement(_FlowListPicker["default"], {
          flowListArray: surveylists ? Object.keys(surveylists) : Object.keys(flowLists),
          onFlowListPicked: this.onFlowListPicked
        });
      }
      if (randomizing || !progressChecked) {
        return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
          loading: true
        });
      }
      var languageInfo = this.languageInfo();
      if (languageInfo.pickerNeeded) {
        if (languagePicker !== null) {
          var picker = /*#__PURE__*/_react["default"].cloneElement(languagePicker, {
            onLanguagePicked: this.onLanguagePicked,
            initialLanguage: languageInfo.language,
            languages: languages
          });
          return {
            picker: picker
          };
        }
        return /*#__PURE__*/_react["default"].createElement(_LanguagePicker["default"], {
          onLanguagePicked: this.onLanguagePicked,
          initialLanguage: languageInfo.language,
          languages: languages
        });
      }
      if (annotatedFlows === undefined) {
        this.getAnnotatedFlows();
        return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
          loading: true
        });
      }
      var MediatorComponent = this.props.mediator || _Mediator["default"];
      mediatorProps.setIsShowingLayoutBgColor = setIsShowingLayoutBgColor;
      mediatorProps.currentLayout = currentLayout;
      return /*#__PURE__*/_react["default"].createElement(MediatorComponent, {
        handle: handle,
        label: label,
        flowList: annotatedFlows,
        language: languageInfo.language,
        onFlowStarted: this.onFlowStarted,
        onFlowComplete: this.onFlowComplete,
        onComplete: this.onComplete,
        onAssignmentComplete: this.onAssignmentComplete,
        onModuleComplete: this.onModuleComplete,
        onAlreadyComplete: this.onAlreadyComplete,
        allowRetake: allowRetake,
        mediatorProps: mediatorProps,
        isFinalTestMode: isFinalTestMode,
        isPreviewMode: isPreviewMode,
        actingPawnHash: this.getPawnHash(),
        actingPawnId: this.getPawnId(),
        isNetworkError: isNetworkError,
        parentDeploymentId: parentDeploymentId,
        relatedDeploymentId: relatedDeploymentId,
        deploymentSettings: deploymentSettings,
        deploymentId: deploymentId
      });
    }
  }]);
  return Assignment;
}(_react["default"].Component);
_defineProperty(Assignment, "propTypes", {
  /** All existing progress for every surveylist/language combination */
  allSurveyProgress: _propTypes["default"].object,
  /** The deployment ID */
  deploymentId: _propTypes["default"].number,
  /** The Deployment settings - to be passed down to the mediator */
  deploymentSettings: _propTypes["default"].object,
  /** The parentDeployment ID, passed through to mediator */
  parentDeploymentId: _propTypes["default"].number,
  /** The relatedDeployment ID, passed through to mediator */
  relatedDeploymentId: _propTypes["default"].number,
  /** The assignment's handle in assignments.json */
  handle: _propTypes["default"].string.isRequired,
  /** The assignment's label in assignments.json; required by some navigations */
  label: _propTypes["default"].string,
  /** The flowLists this assignment has */
  flowLists: _propTypes["default"].object,
  /** The surveylists this assignment has */
  surveylists: _propTypes["default"].object,
  /** The flowList you want to use */
  flowList: _propTypes["default"].string,
  /** An alternate function to replace default flowListRandomizer */
  flowListRandomizer: _propTypes["default"].func,
  /** Should we save the selected flowList to `$pawn->data->flowList`? (default false) */
  shouldSaveFlowList: _propTypes["default"].bool,
  /** An alternate React Component to replace default Mediator */
  mediator: _propTypes["default"].func,
  /** Extra props for mediator */
  mediatorProps: _propTypes["default"].object,
  /** The language you want to use */
  language: _propTypes["default"].string,
  /** The languages this assignment supports */
  languages: _propTypes["default"].array,
  /** An alternate function to replace default LanguagePicker */
  languagePicker: _propTypes["default"].object,
  /** Should we allow changing of language? (default true) */
  allowLanguageChange: _propTypes["default"].bool,
  /** Should we save the selected language to `$pawn->data->language`? (default false) */
  shouldSaveLanguage: _propTypes["default"].bool,
  /** A function to call once assignment is complete (including non-required flows) */
  onComplete: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  /** A function to call when required flows of a module are completed (modules navigation) */
  onModuleComplete: _propTypes["default"].func,
  /** A function to call each time a flow is completed */
  onFlowComplete: _propTypes["default"].func,
  /** A function to call if already complete (including non-required flows) and no retakes allowed */
  onAlreadyComplete: _propTypes["default"].func,
  /** An array of flow progress, i.e., from GraphQL. If provided, is used instead of querying for it. */
  flowProgress: _propTypes["default"].array,
  /** An array of strings for checking against `showIfOption` in flow object entries. If ANY match, flow will be included. */
  options: _propTypes["default"].array,
  /** An array of strings for checking against `showIfOption` in flow object entries.
   * If ANY match, flow `isRequired` setting will be overridden to true.
   * For flows that are not included, `isRequired` will be overridden to false. */
  requiredOptions: _propTypes["default"].array,
  /** Allow a completed assignment to be retaken after completion? */
  allowRetake: _propTypes["default"].bool,
  /** Should we invoke the player in Final Test mode? */
  isFinalTestMode: _propTypes["default"].bool,
  /** Should we skip saving everything and not run any pre/postFlowRoutes? */
  isPreviewMode: _propTypes["default"].bool,
  /** If this an anonymous deployment, should we require a complete captcha before beginning survey? */
  showRecaptcha: _propTypes["default"].bool,
  /** An object containing props that each flow should have */flowProps: function flowProps(props, propName, componentName) {
    var flowProps = props[propName];
    if (_typeof(flowProps) !== 'object') {
      return new Error("Invalid prop ".concat(propName, " supplied to ").concat(componentName, ". Expecting type object but found ").concat(_typeof(flowProps), "."));
    }
    if (flowProps.pawnId && !flowProps.pawnHash && Number(Fortress.user.acting.id) !== Number(flowProps.pawnId)) {
      return new Error("Invalid prop ".concat(propName, " supplied to ").concat(componentName, ". 'pawnHash' must be provided when provided 'pawnId' does not match that of the acting user."));
    }
    if (!flowProps.pawnId && flowProps.pawnHash && Fortress.user.acting.random_hash !== flowProps.pawnHash) {
      return new Error("Invalid prop ".concat(propName, " supplied to ").concat(componentName, ". 'pawnId' must be provided when provided 'pawnHash' does not match that of the acting user."));
    }
  },
  // From redux
  setProgressBar: _propTypes["default"].func,
  // From PlayerLayout, used to toggle bg color in Course Wrapper
  setIsShowingLayoutBgColor: _propTypes["default"].func,
  // From PlayerLayout, provides current layout settings
  currentLayout: _propTypes["default"].object,
  /** It's true if assignment progress is already checked */
  assignmentProgressChecked: _propTypes["default"].bool
});
_defineProperty(Assignment, "defaultProps", {
  allSurveyProgress: null,
  deploymentId: null,
  deploymentSettings: {},
  parentDeploymentId: null,
  relatedDeploymentId: null,
  mediator: null,
  language: null,
  languages: [],
  languagePicker: null,
  shouldSaveLanguage: false,
  allowLanguageChange: true,
  flowList: null,
  flowListRandomizer: null,
  shouldSaveFlowList: false,
  onComplete: null,
  onModuleComplete: null,
  onFlowComplete: null,
  onAlreadyComplete: null,
  flowProgress: null,
  options: [],
  requiredOptions: null,
  allowRetake: false,
  flowProps: {},
  isFinalTestMode: false,
  isPreviewMode: false,
  showRecaptcha: false
});
var ConnectedAssignment = (0, _reactRedux.connect)(null, {
  setProgressBar: _player.setProgressBar
})(Assignment);
var _default = (0, _withRecaptcha["default"])(function (props) {
  return props.showRecaptcha;
})(ConnectedAssignment);
exports["default"] = _default;